var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Option = require('../models/option');

InlineVariations.Collections.Options = Backbone.Collection.extend({
  model: InlineVariations.Models.Option
});

module.exports = InlineVariations.Collections.Options;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9pbmxpbmVfdmFyaWF0aW9ucy9mcm9udGVuZC9jb2xsZWN0aW9ucy9vcHRpb25zLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvaW5saW5lX3ZhcmlhdGlvbnMvZnJvbnRlbmQvY29sbGVjdGlvbnMvb3B0aW9ucy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxnQkFBQSxxQ0FBbUIsTUFBTSxDQUFDLG1CQUFQLE1BQU0sQ0FBQyxtQkFBb0I7OztFQUM5QyxnQkFBZ0IsQ0FBQyxjQUFlOzs7O0VBQ2hDLGdCQUFnQixDQUFDLFNBQVU7OztBQUMzQixnQkFBZ0IsQ0FBQyxNQUFNLENBQUMsTUFBeEIsR0FBaUMsT0FBQSxDQUFRLGtCQUFSOztBQUVqQyxnQkFBZ0IsQ0FBQyxXQUFXLENBQUMsT0FBN0IsR0FBdUMsUUFBUSxDQUFDLFVBQVUsQ0FBQyxNQUFwQixDQUNyQztFQUFBLEtBQUEsRUFBTyxnQkFBZ0IsQ0FBQyxNQUFNLENBQUMsTUFBL0I7Q0FEcUM7O0FBR3ZDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGdCQUFnQixDQUFDLFdBQVcsQ0FBQyJ9
